<template>
  <div>
    <center>
      <div v-if="preiframe" class="preload" style="width:1000px;height:444px;margin-top: 100px;">
      <svg viewBox="0 0 1000 444" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
              <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
                  <stop stop-color="#E5EBEE" offset="0%"></stop>
                  <stop stop-color="#F4F4F4" offset="100%"></stop>
              </linearGradient>
          </defs>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="image">
                  <rect id="Rectangle-path" fill="#E5EBEE" fill-rule="nonzero" x="0" y="396" width="1000" height="48" rx="8"></rect>
                  <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="1000" height="373" rx="6"></rect>
              </g>
          </g>
      </svg>
    </div>
<iframe :class="{ hidden: !iframework }" @load="HidePreiframe(); Showiframe();" class="iframe-create" src="/create.php"></iframe>
    </center>
  </div>
</template>
<script>
export default {
        data() {
          return {
            preiframe: true,
            iframework: false
          }
        },
        methods:{
          HidePreiframe:function(){
                this.preiframe = false;
          },
          Showiframe:function(){
                this.iframework = true;
          }
        }
    }
</script>
<style scoped>
.iframe-create{
  border: 0;
  width: 100%;
  height: 1020px;
}
@media (max-width:1060px) {
  .iframe-create{
    height: 870px!important;
  }
  .preload{
    width:80%!important;
  }
}
@media (max-width:519px) {
  .iframe-create{
    height: 710px!important;
  }
}
.preload:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    background: linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.5),hsla(0,0%,100%,0));
    -webkit-animation: _1IOU .8s linear infinite;
    animation: _1IOU .8s linear infinite;
}
@-webkit-keyframes _1IOU {
            0% {
                -webkit-transform: translateX(-100%);
                transform: translateX(-100%)
            }
            to {
                -webkit-transform: translateX(100%);
                transform: translateX(100%)
            }
        }

        @keyframes _1IOU {
            0% {
                -webkit-transform: translateX(-100%);
                transform: translateX(-100%)
            }
            to {
                -webkit-transform: translateX(100%);
                transform: translateX(100%)
            }
        }
        .hidden{
          opacity:0;
        }
</style>



// WEBPACK FOOTER //
// src/Create.vue